module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/Ham_menu.04090ea8.svg";